import { ApiTags, CommonTagIds } from '@/store/api/tags';

import { NEGOTIATION_STATUSES, PRODUCT_TYPE, Side } from '@/utils/enums';

import { baseApi } from './baseApi';

export type CreateBlockTradeDTO = {
  productType: string;
  buyerCompanyId: string;
  sellerCompanyId: string;
  projectId: string;
  fixedPrice: number;
  tenorStartDate: string;
  tenorMonths: number;
  settlementPoint: string;
  settlementPointIndex: string;
  buyerFraction: number;
  reportingCounterparty: string;
  documentName: string;
  notionalExact: number;
  totalGeneration: number;
  negativePricingMethod?: string;
  applicableRecProgram?: string;
  applicableTrackingSystem?: string;
  recDeliveryMethodology?: string;
  performanceGuaranteeMethod?: string;
  buyerPostCodCollateral?: string;
  sellerPostCodCollateral?: string;
};

export type BlockTradeResponseDTO = {
  negotiationUuid: string;
  negotiationId: number;
  executionId: number;
};

export type BlockTradeListItem = {
  negotiationId: number;
  buyerCompanyName: string;
  sellerCompanyName: string;
  productType: PRODUCT_TYPE;
  fixedPrice: number;
  tenorStart: string;
  tenorMonths: number;
  negotiationStatus: NEGOTIATION_STATUSES;
  updatedAt: string;
  updatedByDisplayName: string | null;
};

const BASE_URL = '/api/v1/admin/block-trades';

export const blockTradeApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getBlockTrades: build.query<BlockTradeListItem[], void>({
      query: () => ({
        url: BASE_URL,
      }),
      providesTags: [{ type: ApiTags.BLOCK_TRADES, id: CommonTagIds.LIST }],
    }),
    createBlockTrade: build.mutation<
      BlockTradeResponseDTO,
      CreateBlockTradeDTO
    >({
      query: data => ({
        url: BASE_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { buyerCompanyId, sellerCompanyId }) => [
        { type: ApiTags.BLOCK_TRADES, id: CommonTagIds.LIST },
        {
          type: ApiTags.NEGOTIATIONS,
          id: `${CommonTagIds.LIST}-${buyerCompanyId}-${Side.BUYER}`,
        },
        {
          type: ApiTags.NEGOTIATIONS,
          id: `${CommonTagIds.LIST}-${sellerCompanyId}-${Side.SELLER}`,
        },
      ],
    }),
  }),
});

export const { useGetBlockTradesQuery, useCreateBlockTradeMutation } =
  blockTradeApi;
